import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  ModalPageHeader,
  ModalPageBody,
  ModalPageFooter,
  ModalPageWrapper,
  ModalPageHeading,
  ModalPageQuestionDescription,
} from "../../../organisms/ModalPage";
import RadioButtonGroup from "../../../molecules/RadioButtonGroup/RadioButtonGroup";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { MentalIllnessRegisterValidationSchema } from "../../../../data/Validation/EligibilityCheckerValidation";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { MentalHealthProps } from "./MentalHealthRoot";

const MentalIllnessRegister: React.FC<MentalHealthProps> = (props: MentalHealthProps) => {
  const { programmeTitle, mentalHealthPageData, nextStepUrl } = props;

  const dispatch = useDispatch();
  const signupFormValues = useSelector((state: any) => state.signupFlowData.signupFormValues);
  const page_title = `Mental health | ${programmeTitle} | ${pageTitleSuffix}`;

  let history = useHistory();

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: page_title,
    });
  }, [page_title]);

  const handleSubmit = values => {
    if (values.mentalillnessRegister === "yes") {
      history.push(`/mental-health/mental-health-management/fail`);
    } else {
      history.push(nextStepUrl);
    }

    // Save values to store
    dispatch(update_signup_form_values(values));
  };

  const initialValues = {
    mentalillnessRegister: signupFormValues?.mentalillnessRegister ?? "",
  };

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={MentalIllnessRegisterValidationSchema}
      validateOnChange={false}
    >
      {({ isSubmitting, values, touched, errors }) => (
        <Form className="eligibility-checker-form mental-health-form">
          <Helmet>
            <title>{page_title}</title>
          </Helmet>
          <ModalPageWrapper>
            <ModalPageBody className="with-sticky-footer">
              <ModalPageHeader
                backButtonOnClick={() => {
                  history.goBack();
                }}
              >
                Checking we're a good fit
              </ModalPageHeader>

              <ModalPageHeading>{mentalHealthPageData?.questions[2].question}</ModalPageHeading>
              <ModalPageQuestionDescription>
                {mentalHealthPageData?.questions[2].description}
              </ModalPageQuestionDescription>
              <RadioButtonGroup
                options={yesNoOptions}
                name="mentalillnessRegister"
                hasErrors={errors["mentalillnessRegister"] && touched["mentalillnessRegister"]}
              />
            </ModalPageBody>
            <ModalPageFooter className="sticky-footer">
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                Continue
              </Button>
            </ModalPageFooter>
          </ModalPageWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default MentalIllnessRegister;
